import { IFilter } from "@saleor/components/Filter";
import { commonMessages } from "@saleor/intl";
import {
  LanguagesMessages,
  orderReferCodeMessages,
  orderStatusMessages,
  paymentStatusMessages
} from "@saleor/misc";
import { FilterOpts, MinMax } from "@saleor/types";
import {
  LanguageCodeFilter,
  // OrderReferCode,
  OrderRefercodeFilter,
  OrderStatusFilter,
  PaymentChargeStatusEnum
} from "@saleor/types/globalTypes";
import {
  createDateField,
  createOptionsField,
  createTextField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum OrderFilterKeys {
  created = "created",
  customer = "customer",
  status = "status",
  couponcode = "couponcode",
  languageCode = "languageCode",
  paymentStatus = "paymentStatus",
  refercode = "refercode"
}

export interface OrderListFilterOpts {
  created: FilterOpts<MinMax>;
  customer: FilterOpts<string>;
  couponcode: FilterOpts<string>;
  status: FilterOpts<OrderStatusFilter[]>;
  languageCode: FilterOpts<LanguageCodeFilter[]>;
  paymentStatus: FilterOpts<PaymentChargeStatusEnum[]>;
  refercode: FilterOpts<OrderRefercodeFilter[]>;
}

const messages = defineMessages({
  customer: {
    defaultMessage: "Customer",
    description: "order"
  },
  couponcode: {
    defaultMessage: "Coupon Code",
    description: "order"
  },
  placed: {
    defaultMessage: "Created",
    description: "order"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: OrderListFilterOpts
): IFilter<OrderFilterKeys> {
  return [
    {
      ...createTextField(
        OrderFilterKeys.customer,
        intl.formatMessage(messages.customer),
        opts.customer.value
      ),
      active: opts.customer.active
    },
    {
      ...createTextField(
        OrderFilterKeys.couponcode,
        intl.formatMessage(messages.couponcode),
        opts.couponcode.value
      ),
      active: opts.couponcode.active
    },
    {
      ...createDateField(
        OrderFilterKeys.created,
        intl.formatMessage(messages.placed),
        opts.created.value
      ),
      active: opts.created.active
    },
    {
      ...createOptionsField(
        OrderFilterKeys.status,
        intl.formatMessage(commonMessages.status),
        opts.status.value,
        true,
        [
          {
            label: intl.formatMessage(orderStatusMessages.cancelled),
            value: OrderStatusFilter.CANCELED
          },
          {
            label: intl.formatMessage(orderStatusMessages.fulfilled),
            value: OrderStatusFilter.FULFILLED
          },
          {
            label: intl.formatMessage(orderStatusMessages.partiallyFulfilled),
            value: OrderStatusFilter.PARTIALLY_FULFILLED
          },
          {
            label: intl.formatMessage(orderStatusMessages.unfulfilled),
            value: OrderStatusFilter.UNFULFILLED
          },
          {
            label: intl.formatMessage(orderStatusMessages.readyToCapture),
            value: OrderStatusFilter.READY_TO_CAPTURE
          },
          {
            label: intl.formatMessage(orderStatusMessages.readyToFulfill),
            value: OrderStatusFilter.READY_TO_FULFILL
          }
        ]
      ),
      active: opts.status.active
    },
    {
      ...createOptionsField(
        OrderFilterKeys.paymentStatus,
        intl.formatMessage(commonMessages.paymentStatus),
        opts.paymentStatus.value,
        true,
        [
          {
            label: intl.formatMessage(paymentStatusMessages.partiallyPaid),
            value: PaymentChargeStatusEnum.PARTIALLY_CHARGED
          },
          {
            label: intl.formatMessage(paymentStatusMessages.paid),
            value: PaymentChargeStatusEnum.FULLY_CHARGED
          },
          {
            label: intl.formatMessage(paymentStatusMessages.partiallyRefunded),
            value: PaymentChargeStatusEnum.PARTIALLY_REFUNDED
          },
          {
            label: intl.formatMessage(paymentStatusMessages.refunded),
            value: PaymentChargeStatusEnum.FULLY_REFUNDED
          },
          {
            label: intl.formatMessage(paymentStatusMessages.unpaid),
            value: PaymentChargeStatusEnum.CANCELLED
          }
        ]
      ),
      active: opts.paymentStatus.active
    },
    {
      ...createOptionsField(
        OrderFilterKeys.refercode,
        intl.formatMessage(commonMessages.refercode),
        opts.refercode.value,
        true,
        [
          {
            label: intl.formatMessage(orderReferCodeMessages.refercode),
            value: OrderRefercodeFilter.REFER_CODE
          }
        ]
      ),
      active: opts.refercode.active
    },
    {
      ...createOptionsField(
        OrderFilterKeys.languageCode,
        intl.formatMessage(commonMessages.languages),
        opts.languageCode.value,
        true,
        [
          {
            label: intl.formatMessage(LanguagesMessages.en),
            value: LanguageCodeFilter.EN
          },
          {
            label: intl.formatMessage(LanguagesMessages.ar),
            value: LanguageCodeFilter.AR
          },
          {
            label: intl.formatMessage(LanguagesMessages.pt),
            value: LanguageCodeFilter.PT
          },
          {
            label: intl.formatMessage(LanguagesMessages.de),
            value: LanguageCodeFilter.DE
          },
          {
            label: intl.formatMessage(LanguagesMessages.es),
            value: LanguageCodeFilter.ES
          },
          {
            label: intl.formatMessage(LanguagesMessages.fr),
            value: LanguageCodeFilter.FR
          },
          {
            label: intl.formatMessage(LanguagesMessages.ja),
            value: LanguageCodeFilter.JA
          },
          {
            label: intl.formatMessage(LanguagesMessages.zh_hans),
            value: LanguageCodeFilter.ZH_HANS
          },
          {
            label: intl.formatMessage(LanguagesMessages.zh_hant),
            value: LanguageCodeFilter.ZH_HANT
          }
        ]
      ),
      active: opts.languageCode.active
    }
  ];
}
